import styled from 'styled-components';
import { FlexibleDiv } from '../../../styled/common';
import { StepModalOption } from '../styled';
import { Breakpoints } from '../../../styled/constants';

export const SelectCategoryOptionWrapper = styled(FlexibleDiv)`
  width: 100%;
  height: 100%;
  gap: 20px;
  flex-wrap: wrap;
`;

export const SelectCategoryOption = styled(StepModalOption)`
  padding: 18px;
  flex: 1 1 calc(50% - 20px);
  text-align: center;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 30px 15px;
    flex: 1 1 calc(33.33% - 20px);
  }
`;
